"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_accordion_1 = require("@hotelplan/components.common.accordion");
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const DestinationAttributes_mappers_1 = require("./DestinationAttributes.mappers");
const DestinationRating_1 = __importDefault(require("./DestinationRating"));
const AttributeDetailList = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    p: 3,
}));
const AttributeDetailWrapMobile = styled_components_1.default.div(({ theme }) => theme.destinationAttributes.attributeDetailWrapMobile);
const AttributeWrapMobile = styled_components_1.default.div(({ theme }) => theme.destinationAttributes.attributeWrapMobile);
const AttributeIcon = (0, styled_components_1.default)(components_common_icon_1.Icon).attrs({
    variant: `lg`,
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    verticalAlign: 'text-top',
    mr: [2, '10px'],
}));
const DestinationAttributesMobile = props => {
    const { attributes } = props;
    return (react_1.default.createElement(components_common_accordion_1.Accordion, { mode: components_common_accordion_1.AccordionMode.MULTIPLE }, attributes.map((attribute, i) => {
        return (react_1.default.createElement(components_common_accordion_1.AccordionItem, { key: i, title: react_1.default.createElement(AttributeWrapMobile, null,
                react_1.default.createElement("span", { className: "attributeName" },
                    react_1.default.createElement(AttributeIcon, { name: (0, DestinationAttributes_mappers_1.mapAttributeNameToIcon)(attribute.id) }),
                    attribute.name),
                react_1.default.createElement("div", { className: "ratingWrap" },
                    react_1.default.createElement(DestinationRating_1.default, { rating: attribute.rating }))) },
            react_1.default.createElement(AttributeDetailList, null, (attribute.details || []).map((attributeDetail, idx) => {
                return (react_1.default.createElement(AttributeDetailWrapMobile, { key: attributeDetail.id || idx },
                    react_1.default.createElement("span", { className: "attributeDetailName" }, attributeDetail.name),
                    react_1.default.createElement("div", { className: "attributeRatingWrap" },
                        react_1.default.createElement(DestinationRating_1.default, { subRating: true, rating: attributeDetail.rating }))));
            }))));
    })));
};
exports.default = DestinationAttributesMobile;
//# sourceMappingURL=DestinationAttributesMobile.js.map